import axios from 'axios';

const bxUrl = axios.create({
    baseURL: process.env.VITE_HOST,
    withCredentials: true,
})

const CSRF_METHODS = new Set(['post', 'put', 'patch', 'delete']);

const apiUrl = axios.create({
    baseURL: process.env.VITE_HOST_API,
    withCredentials: true,
    // axios ≥1.6 прикрепляет X-XSRF-TOKEN к КРОСС-доменным запросам только при
    // явном withXSRFToken. Запросы идут на api.testometrika.com (другой origin),
    // поэтому без токена POST/PUT/PATCH/DELETE на web-сессионные роуты (/api/wgt …)
    // получают 419 CSRF token mismatch. XSRF-TOKEN cookie шарится по
    // .testometrika.com (как и сессия), так что токен доступен для чтения.
    // GET сервер на CSRF не проверяет, а лишний заголовок делал бы его «непростым»
    // CORS-запросом: браузер слал бы перед каждым GET preflight OPTIONS.
    withXSRFToken: ({ method }) => CSRF_METHODS.has(method),
});

// Интерсептор для добавления заголовка Content-Language.
// Полная locale из сервера ('ru', 'en', 'en-US') — Localization middleware принимает оба формата.
// Fallback 'ru' — для тестовых окружений, где window.App недоступен.
apiUrl.interceptors.request.use(config => {
    config.headers['Content-Language'] = window.App?.locale ?? 'ru';
    return config;
}, error => {
    return Promise.reject(error);
});

export { apiUrl, bxUrl, axios };

